/* eslint-disable import/prefer-default-export */
import axios from "axios";
import {
  SET_LOADING,
  GET_REQUESTS,
  REQUEST_FAIL,
  MARK_AS_READ_SUCCESS,
  MARK_AS_READ_FAILURE,
} from "./Types";

const factory = require("./actionsFactory");

// URL
const URL = process.env.REACT_APP_API;
// Set loading
export const setLoading = () => (dispatch) => {
  dispatch({
    type: SET_LOADING,
  });
};

export const getLocationRequests = (locationId, startDate, endDate, locationIds) => {
  let queryParams = "";

  if (startDate && endDate) {
    queryParams = `startDate=${startDate}&endDate=${endDate}`;
  }

  if (locationIds && locationIds.length > 0) {
    const locationIdsParam = locationIds.join(",");
    queryParams += queryParams
      ? `&locationIds=${locationIdsParam}`
      : `locationIds=${locationIdsParam}`;

    return factory.get(`${URL}/locations/jobsRequests?${queryParams}`, GET_REQUESTS, REQUEST_FAIL);
  }

  if (locationIds !== undefined && locationIds.length === 0) {
    return factory.get(`${URL}/stats/jobsRequests?${queryParams}`, GET_REQUESTS, REQUEST_FAIL);
  }

  return factory.get(
    `${URL}/locations/${locationId}/jobsRequests?${queryParams}`,
    GET_REQUESTS,
    REQUEST_FAIL
  );
};

export const markAsOrdered = (id) => async (dispatch) => {
  const config = {
    headers: { "Content-Type": "application/json" },
  };

  const body = {};

  try {
    const response = await axios.post(`${URL}/order/${id}/confirmStoreOrder `, body, config);
    dispatch({ type: MARK_AS_READ_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: MARK_AS_READ_FAILURE, error: error.message });
  }
};

// function for Location Requests (Status)
export const updateLocationRequest = (locationId, data) =>
  factory.patch(
    { status: data?.status, requestId: data?.requestId, type: data?.type },
    `${URL}/locations/${locationId}/jobsRequests`,
    "UPDATE_JOB_REQUEST",
    "REQUEST_FAIL"
  );
